// Lógica del paso "Confirmación" del formulario v2, sin pantalla. Las mismas reglas valida el
// backend (validar_aceptaciones): la política siempre; el consentimiento informado solo en
// Psicología; los datos sensibles solo si hubo caracterización.
export const PASO_CONFIRMACION = "Confirmación";
export const CODIGO_PSICOLOGIA = "14011";

// Casillas obligatorias según el programa elegido y si hubo caracterización
export function aceptacionesRequeridas(carrera, conCaracterizacion) {
  return [
    { clave: "politica", mensaje: "Debes aceptar las políticas de protección de datos." },
    ...(carrera && carrera.codigo == CODIGO_PSICOLOGIA
      ? [{ clave: "consentimiento", mensaje: "Debes aceptar el consentimiento informado para la prueba psicotécnica." }]
      : []),
    ...(conCaracterizacion
      ? [{ clave: "datos_sensibles", mensaje: "Debes autorizar el tratamiento de tus datos sensibles." }]
      : []),
  ];
}

// Nombre con el que se marca en rojo la casilla (campo_error)
export const campoAceptacion = (clave) => `acepta_${clave}`;
